import Component from '../abstracts/Component';
import { doAjax } from '../utils/ajaxUtil';
import SimpleCarouselComponent from "./SimpleCarouselComponent";
import CarouselModuleComponent from "./CarouselModuleComponent";
import VideoBrightcoveComponent from "./VideoBrightcoveComponent";

export default class PdpExtendedComponent extends Component {

  get SELECTORS() {
    return {
      main: '.js-addtocart',
      editorialAreaBefore: '[data-editorial-content-before]',
      editorialAreaAfter: '[data-editorial-content-after]',
    }
  }

  constructor() {
    super();
  }

  bindExtendedPDP() {
    // general
    let ctx = this;
    // vars
    let elem = document.querySelector('.jsToBagBtn');
    let pdpElement = document.querySelector('.c-pdp-main');
    //
    if(elem != null) {
      //const sku = document.querySelector('.jsToBagBtn').dataset.productCode
      const sku = pdpElement.getAttribute('data-product-code');
      doAjax({
          type: 'POST',
          url: '/action/ajax/specialpdpcheck',
          data: {
            sku: sku
          }
        })
        .done(resp => {
          if(resp) {
            doAjax({
                type: 'POST',
                url: '/action/ajax/specialpdp',
                data: {
                  sku: sku
                }
              })
              .done(resp => {
                // render the components
                ctx.renderComponents(resp);
              })
              .fail(xhr => {
                this.log('Related page not found');
              })
              .always((xhr) => {
                // no action
              });
          }
        })
        .fail(xhr => {
          this.log('Related page not found');
        })
        .always((xhr) => {
          // no action
        });
    }
  }

  renderComponents(html) {
    // parse the html
    let response = new DOMParser().parseFromString(html, 'text/html');
    //
    this.renderHtml(response,this.SELECTORS.editorialAreaBefore);
    this.renderHtml(response,this.SELECTORS.editorialAreaAfter);
    // launch event
    this.$emit(this.$customEvents.PRODUCT_EVENTS.editorialcontentloaded,{});
  }

  // render results
  renderHtml(response,selector) {
    // html response
    let source = response.querySelector(selector);
    let target = document.querySelector(selector);
    // update the html
    if(typeof source !== 'undefined' && source != null && typeof target !== 'undefined' && target != null ) {
      target.innerHTML = source.innerHTML;
    }
  }

  initComponents(components) {
    if (components !== null && components.length > 0 ) {
      components.forEach(component => {
        if (!component.classList.contains('component-loaded')) {
          // video
          if (component.dataset.jsComponent === 'VideoBrightcoveComponent') {
            let instance = new VideoBrightcoveComponent(component);
            instance.init();
          }
          // SimpleCarouselComponent
          if (component.dataset.jsComponent === 'SimpleCarouselComponent') {
            let instance = new SimpleCarouselComponent(component);
            instance.initAsynchCarousel();
          }
          // CarouselModuleComponent
          if (component.dataset.jsComponent === 'CarouselModuleComponent') {
            let instance = new CarouselModuleComponent(component);
            instance.render();
          }
        }
      });
    }
  }

  bindEvents() {
    //
    let ctx = this;
    //
    this.$on(this.$customEvents.PRODUCT_EVENTS.editorialcontentloaded, () => {
      // before area :scope >
      let beforeArea = document.querySelector(this.SELECTORS.editorialAreaBefore);
      let beforeComponents = beforeArea.querySelectorAll("[data-js-component]");
      //
      ctx.initComponents(beforeComponents);
      // after area
      let afterArea = document.querySelector(this.SELECTORS.editorialAreaAfter);
      let afterComponents = afterArea.querySelectorAll("[data-js-component]");
      //
      ctx.initComponents(afterComponents);
    });

  }

  render() {
    this.log('Rendering...');
    // main pdp function
    this.bindExtendedPDP();
    // events for components
    this.bindEvents();
  }

}
